import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_2 = { class: "col-1 mt-3 mb-3" }
const _hoisted_3 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_6 = { class: "visually-hidden" }
const _hoisted_7 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_8 = { class: "col" }
const _hoisted_9 = {
  key: 2,
  class: "row justify-content-center"
}
const _hoisted_10 = { class: "col-12 text-center mb-4" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "col-12"
}

import { onMounted, ref, inject, onUnmounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import { useTenantConfig } from "../../composables/useTenantConfig";
import api from "@/services/BookingService";
import _ from "lodash";
import { LocationModel } from "@/models/Step/LocationModel";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'Frontoffice',
  setup(__props) {

const { getSelectionMode } = useTenantConfig();
const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");

const selectedItem = ref(null);
const loading = ref(false);
const loadingConfig = ref(false);
const serviceNotSet = ref(false);
const rooms = ref(null);
const locations = ref([]);
const replaceRouteNavigation = ref(false);

onMounted(() => {
    loadingConfig.value = true;

    emitter.on(constants.GO_NEXT_STEP, () => {
        console.log("received goNextStep Frontoffice");
        goToNextStep();
    });

    // Se non è stato impostato il servizio (magari query string errata), mostro msg di errore

    if (store.stepsMade && store.stepsMade.service) {
        loadingConfig.value = false;
        getData();
        store.stepsMade.location = null;
    } else {
        serviceNotSet.value = true;
        loadingConfig.value = false;
    }
});

watch(
    () => selectedItem.value,
    (newVal) => {
        if (newVal) {
            emitter.emit(constants.CAN_GO_NEXT_STEP, true);
        } else {
            emitter.emit(constants.CAN_GO_NEXT_STEP, false);
        }
    },
    { immediate: true }
);

const getData = () => {
    loading.value = true;

    const serviceIds: number[] = [];
    serviceIds.push(parseInt(store.stepsMade.service.id));

    // imposto il filtro comuni sia se selezionato dall'utente che se impostato da query string...altrimenti niente
    let comuni: string[] = [];
    // Per prima cosa guardo se è stato selezionato il comune dall'utente (nel caso fosse abilitata la selezione)
    if (store.stepsMade && store.stepsMade.municipality) {
        comuni.push(store.stepsMade.municipality);
    }
    // altrimenti guardo se mi è stato passato come filtro nella query string
    else if (store.municipalityFilter && store.municipalityFilter.length > 0) {
        comuni = store.municipalityFilter;
    }

    api.getLocations(store.tenantSelected.id, serviceIds, comuni, store.roomTypeFilter)
        .then((result) => {
            if (_.isNull(result) === false && _.isUndefined(result) === false) {
                if (_.isNull(result.data) === false && _.isUndefined(result.data) === false && _.isArray(result.data) && result.data.length > 0) {
                    rooms.value = result.data;

                    if (rooms.value.length > 0) {
                        //extract the locations
                        const roomlocations: LocationModel[] = rooms.value.map(function (item: { location: { id: string; name: string; roomType: number; city: string } }) {
                            const location = new LocationModel();
                            location.id = item.location.id;
                            location.name = item.location.name;
                            location.roomType = item.location.roomType;
                            location.city = item.location.city;
                            return location;
                        });

                        const uniqLocation = _.uniqBy(roomlocations, function (item: LocationModel) {
                            return item.id;
                        });

                        if (uniqLocation.length === 1 && uniqLocation[0].roomType === 2) {
                            setLocation(uniqLocation[0], true);
                            goToNextStep();
                        } else {
                            locations.value = uniqLocation;
                        }
                    }
                }
            }

            loading.value = false;
        })
        .catch((err: any) => {
            console.log("Errore nella get delle room");

            rooms.value = err;

            if (rooms.value.length > 0) {
                //extract the locations
                const roomlocations: LocationModel[] = rooms.value.map(function (item: { location: { id: string; name: string; roomType: number } }) {
                    const location = new LocationModel();
                    location.id = item.location.id;
                    location.name = item.location.name;
                    location.roomType = item.location.roomType;
                    return location;
                });

                const uniqLocation = _.uniqBy(roomlocations, function (item: LocationModel) {
                    return item.id;
                });

                locations.value = uniqLocation;
            }

            loading.value = false;
        });
};

const isItemSelected = (locationId: string) => {
    if (_.isNull(selectedItem.value) === false) {
        if (selectedItem.value.id === locationId) {
            return true;
        }
    }
    return false;
};

const bookEditHasSameLocation = (locationId: string) => {
    if (_.isNull(store.bookedit) === false && store.bookedit.room && store.bookedit.room.location && store.bookedit.room.location.id) {
        if (store.bookedit.room.location.id === locationId) {
            return true;
        }
    }
    return false;
};

const setLocation = (location: LocationModel, replaceRoute = false) => {
    if (_.isNull(location) === false) {
        selectedItem.value = location;
        replaceRouteNavigation.value = replaceRoute;
    } else {
        alert("Errore nella scelta dello Sportello Digitale");
    }
};

const goToNextStep = () => {
    store.stepsMade.location = selectedItem.value;
    const dateSelectionMode = getSelectionMode("dateselection.web");
    if (replaceRouteNavigation.value) {
        if (dateSelectionMode == "nextxdays") {
            router.replace({ name: "bookdate" });
        } else if (dateSelectionMode == "nextxdayshour") {
            router.replace({ name: "bookdatehour" });
        } else {
            router.replace({ name: "bookmonth" });
        }
    } else {
        if (dateSelectionMode == "nextxdays") {
            router.push({ name: "bookdate" });
        } else if (dateSelectionMode == "nextxdayshour") {
            router.push({ name: "bookdatehour" });
        } else {
            router.push({ name: "bookmonth" });
        }
    }
};

onUnmounted(() => emitter.off(constants.GO_NEXT_STEP));

return (_ctx: any,_cache: any) => {
  return (loading.value || loadingConfig.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.loadingText")), 1)
          ])
        ])
      ]))
    : (serviceNotSet.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)("messages.noServiceSelected")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectLocation")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (location) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-md-6 col-xxl-4 d-grid gap-2",
              key: location.id
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-lg my-3", [isItemSelected(location.id) ? 'btn-primary' : 'btn-outline-primary']]),
                onClick: ($event: any) => (setLocation(location))
              }, _toDisplayString(location.name), 11, _hoisted_11)
            ]))
          }), 128)),
          (!loading.value && locations.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("label", null, _toDisplayString(_unref(t)("messages.noLocationFound")), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
}
}

})